import { StarCheckIcon } from './StarCheckIcon';

/**
 * author: Michael Irigoyen
 * id 6AB2A77F-C9ED-4EF1-BDD3-4E060E690A7E
 * name star-check
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-check.svg
 * tags
 * - Shape 
 */
export const FavoriteCheckIcon = StarCheckIcon;
export default FavoriteCheckIcon